import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { carbon } = colorsPalettes;

export const SearchContainer = styled(FlexRow)`
    align-items: center;
    padding: 8px 16px 8px 0;
    height: 40px;
    border-bottom: 1px solid ${carbon[50]};
    .SearchInput-container {
        flex-grow: 1;
    }
    .SearchInput-container .SearchInput {
        height: 34px;
        background-color: ${carbon[0]};
        border: none;
        width: 100%;
        box-sizing: border-box;
        padding: 9px 2px 5px 50px;
        box-shadow: none;
        margin-bottom: 0;
        &:focus {
            box-shadow: none !important;
            border: none;
        }
    }
`;
